import { createTheme, responsiveFontSizes } from '@mui/material';

// theme override
let theme = createTheme({
  palette:{
    primary:{
        main:"#95AAC5"
    },
    secondary:{
        main:"#A3ADAE"
    },
    background:{
        paper:"#CCC",
        default:"#FFFFFF",
        black:"#000"
    }
  },
  // general style override
  typography: {
    allVariants: {
      fontWeight: "lighter", // Applies to all text variants
    },
  },
  // component style override
  components:{
    MuiButton:{
      styleOverrides:{
        root:{
          borderRadius:0,
          fontWeight:"lighter",
          paddingLeft:30,
          paddingRight:30,
          color:"#FFF",
        }
      }
    }
  }

})

theme = responsiveFontSizes(theme)

export default theme;